import { create } from 'zustand';

interface PublicNavBarState {
  isOpen: boolean;
  
  // Actions
  setIsOpen: (open: boolean) => void;
  
  // Toggle state
  toggleIsOpen: () => void;
}

export const usePublicNavBarStore = create<PublicNavBarState>((set) => ({
  isOpen: false,
  
  setIsOpen: (open) => set({ isOpen: open }),
  
  toggleIsOpen: () => set((state) => ({ isOpen: !state.isOpen })),
}));
